import axios from "@/plugins/axios";

export default {
  getAllAddress() {
    return axios
      .get("/ebsn/api/eurospin-b2b-registration/list-all", {
        params: {}
      })
      .then(data => {
        return data.data.data.addresses;
      });
  },
  updateAddress(address) {
    return axios
      .post("/ebsn/api/eurospin-b2b-registration/update", address)
      .then(data => {
        if (data.data.response.status == 0) {
          global.EventBus.$emit("success", {
            message: "addresses.setAddress"
          });
          return data.data.data;
        } else {
          return false;
        }
      });
  },

  registerUser(user) {
    let url = "/ebsn/api/eurospin-b2b-registration/register_user";
    return axios
      .post(url, user)
      .then(response => {
        return response.data.data.user;
      })
      .catch(err => err);
  },

  registerUserWithCard(user) {
    let url = "/ebsn/api/eurospin-b2b-registration/register_user_with_card";
    return axios
      .post(url, user)
      .then(response => {
        return response.data.data.user;
      })
      .catch(err => err);
  },
  checkCard(user) {
    return axios
      .get("/ebsn/api/eurospin-b2b-registration/lookup_user", {
        params: { card: user.fidelityCard, piva_cf: user.person.fiscalCode }
      })
      .then(data => data.data)
      .catch(error => error);
  },
  registerPerson(user) {
    let url = "/ebsn/api/eurospin-b2b-registration/register_person";
    return axios
      .post(url, user)
      .then(response => {
        return response.data;
      })
      .catch(error => error);
  },
  getResetPasswordToken(email) {
    let url = "/ebsn/api/registration/password_reset_token_request";
    return axios
      .get(url, {
        params: { e_mail: email }
      })
      .then(data => {
        if (data.data.response.status == 0) {
          return data.data;
        } else {
          Promise.reject(data);
        }
      });
  },
  confirmRegistration(email, controlCode, newEmail) {
    let url = "/ebsn/api/registration/registration_confirm";
    return axios
      .get(url, {
        params: {
          e_mail: email,
          reg_control_code: controlCode,
          new_email: newEmail
        }
      })
      .then(response => {
        return response.data.response;
      });
  },
  updatePassword(oldPassword, newPassword) {
    let url = "/ebsn/api/registration/update_password";
    return axios
      .get(url, {
        params: { old_password: oldPassword, new_password: newPassword }
      })
      .then(data => {
        return data.data;
      });
  },
  getProvinces(countryId, homeDeliveryOnly) {
    return axios
      .get("/ebsn/api/geo/province-list", {
        params: {
          country_id: countryId,
          home_delivery_only: homeDeliveryOnly
        }
      })
      .then(data => {
        return data.data.data.results;
      });
  },
  getCities(provinceId, homeDeliveryOnly) {
    return axios
      .get("/ebsn/api/geo/city-list", {
        params: {
          province_id: provinceId,
          home_delivery_only: homeDeliveryOnly
        }
      })
      .then(data => {
        return data.data.data.results;
      });
  },
  getPostalCodes(cityId, homeDeliveryOnly) {
    return axios
      .get("/ebsn/api/geo/postcode-list", {
        params: {
          city_id: cityId,
          home_delivery_only: homeDeliveryOnly
        }
      })
      .then(data => {
        return data.data.data.results;
      });
  }
};
